import { useState, useEffect, useRef } from "react";

function BookMeetingPage() {
  const [dateTime, setDateTime] = useState("");
  const [errors, setErrors] = useState({});
  const emailRef = useRef(null);
  const formRefs = {
    firstName: useRef(null),
    lastName: useRef(null),
    company: useRef(null),
    jobTitle: useRef(null),
    email: useRef(null),
    phone: useRef(null),
  };

  useEffect(() => {
    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 16);
    setDateTime(formattedDateTime);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    // 빈 값 검사
    for (const field in formRefs) {
      if (!formRefs[field].current.value.trim()) {
        newErrors[field] = "The " + formRefs[field].current.placeholder+" field is required.";
      }
    }

    // 이메일 형식 검사
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formRefs.email.current.value)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // 에러가 있으면 포커스
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      formRefs[Object.keys(newErrors)[0]].current.focus();
    } else {
      setErrors({});
      e.target.submit();
    }
  };

  return (
    <>
      <div className="relative bg-brand-silicon-white text-black font-pretendard mx-auto w-full px-5 flex items-center flex-col overflow-x-hidden overflow-y-scroll">
        <div className="bg-white rounded-lg sm:p-5 p-5 my-10 shadow-2xl">
          <h2 className="flex w-full text-xl mb-1 text-left">
            Book a Meeting with&nbsp;
            <span className="font-[700]">KoolMicro™</span>
          </h2>
          <div className="font-thin mb-10">January 7-10&nbsp;@&nbsp;CES2025</div>
          <form
            className="sm:w-[40rem] w-full"
            action="https://docs.google.com/forms/d/e/1FAIpQLSfqQ0n6f_TEtbbSW01jsvWErxI4tTlhin4-ad00UN2x01dHKQ/formResponse"
            method="POST"
            target="_blank"
            onSubmit={handleSubmit}
          >
            <div className="flex w-full mb-4">
              <input
                type="text"
                placeholder="First Name"
                name="entry.162654557"
                ref={formRefs.firstName}
                className={`w-full me-2 p-2 rounded-md border ${
                  errors.firstName ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
              <input
                type="text"
                placeholder="Last Name"
                name="entry.291597505"
                ref={formRefs.lastName}
                className={`w-full ms-2 me-2 p-2 rounded-md border ${
                  errors.lastName ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
            </div>
            <div className="flex w-full mb-4">
              <input
                type="text"
                placeholder="Company"
                name="entry.580869048"
                ref={formRefs.company}
                className={`w-full me-2 p-2 rounded-md border ${
                  errors.company ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
              <input
                type="text"
                placeholder="Job title"
                name="entry.843321062"
                ref={formRefs.jobTitle}
                className={`w-full ms-2 me-2 p-2 rounded-md border ${
                  errors.jobTitle ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
            </div>
            <div className="flex w-full mb-4">
              <input
                type="email"
                placeholder="Email"
                name="entry.426382015"
                ref={formRefs.email}
                className={`w-full me-2 p-2 rounded-md border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
              <input
                type="text"
                placeholder="Phone Number"
                name="entry.1640321336"
                ref={formRefs.phone}
                className={`w-full ms-2 me-2 p-2 rounded-md border ${
                  errors.phone ? "border-red-500" : "border-gray-300"
                } text-black`}
              />
            </div>
            {Object.keys(errors).map((key) => (
              <div key={key} className="text-red-500 text-sm mb-4">
                {errors[key]}
              </div>
            ))}
            <div className="flex flex-col w-full mb-4">
              <div className="font-[700] mt-5 ms-1 mb-1">Preferred Date and Time</div>
              <input
                type="datetime-local"
                id="datetime"
                name="entry.1873283057"
                value={dateTime}
                className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-700"
              />
            </div>
            <textarea
              placeholder="Subject"
              className="w-full h-[10rem] p-2 rounded-md border border-gray-300 text-black"
              rows="3"
              name="entry.2020154100"
            ></textarea>
            <div className="flex justify-center items-center text-lg mt-5 mb-5">
              <button
                type="submit"
                className="w-[15rem] shadow-md bg-brand-kool-blue hover:bg-brand-darker-blue text-gray-100 font-bold p-2 rounded-md"
              >
                Request Meeting
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default BookMeetingPage;
